import React, { useState, useEffect, useCallback } from "react";
import { heroSlides, personalInfo } from "../../data/portfolioData";

const HeroSlider = () => {
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % heroSlides.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  return (
    <section className="hero-section" id="home">
      {heroSlides.map((slide, i) => (
        <div
          key={slide.id}
          className={`hero-slide ${i === current ? "active" : ""}`}
          style={{
            backgroundImage: `url(${slide.image})`,
            backgroundPosition: slide.bgPos || "center center",
          }}
        >
          <div className="hero-overlay" />
        </div>
      ))}

      <div className="hero-content">
        <div className="hero-text">
          <h1>
            {heroSlides[current].heading.split("\n").map((line, i) => (
              <span key={i}>
                {i > 0 && <br />}
                {line}
              </span>
            ))}
          </h1>
          <p>{heroSlides[current].subheading}</p>
          <div className="hero-actions">
            <a
              href={personalInfo.cvLink}
              target="_blank"
              rel="noreferrer"
              className="btn-primary"
            >
              <i className="fas fa-download"></i> Download CV
            </a>
            <a
              href="#contact"
              className="btn-outline"
              onClick={(e) => {
                e.preventDefault();
                document
                  .getElementById("contact")
                  ?.scrollIntoView({ behavior: "smooth" });
              }}
            >
              <i className="fas fa-envelope"></i> Contact Me
            </a>
          </div>
        </div>
      </div>

      <div className="hero-dots">
        {heroSlides.map((_, i) => (
          <button
            key={i}
            className={`hero-dot ${i === current ? "active" : ""}`}
            onClick={() => setCurrent(i)}
          />
        ))}
      </div>
    </section>
  );
};

export default HeroSlider;
